<template>
  <div class="heart-sound-check">
    <md-chip class="md-primary">Heart sound is</md-chip>
    <!-- Multiple heart sound spots might become relevant later when we do cardiac cases -->
    <!-- <md-field>
      <md-select
        class="spot-select"
        :value="state.check.spots"
        @input="spots => selectSpots(spots)"
        placeholder="any spot"
        :multiple="true"
        :disabled="readonly"
      >
        <md-menu-item @click="selectSpots([])">
          <md-checkbox class="md-primary" v-model="isAnySpot">Any</md-checkbox>
        </md-menu-item>
        <md-option
          v-for="spot in heartSoundSpots"
          :key="spot"
          :value="spot"
          class="spot-option"
        >{{ spot + 1 }}</md-option>
      </md-select>
    </md-field> -->
    <!-- <md-chip class="md-primary">is</md-chip> -->
    <md-field>
      <md-select
        v-close-on-zoom
        class="sound-select"
        :value="state.check.value"
        placeholder="Select a sound"
        :disabled="readonly"
        @input="sound => setValue(sound)"
      >
        <md-option
          v-for="sound in heartSounds"
          :key="sound.id"
          :value="sound.resourceName"
          class="sound-option"
        >
          {{ sound.resourceName }}
        </md-option>
      </md-select>
    </md-field>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'heart-sound-check',
  components: {},
  props: [
    'sounds',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        check: {},
      },
      heartSounds: this.sounds.filter(s => s.category === 'heart'),
      // Multiple heart sound spots might become relevant later when we do cardiac cases
      // heartSoundSpots: [0, 1, 2, 3, 4],
    };
  },
  computed: {
    isAnySpot: {
      get() {
        return isEmpty(this.state.check.spots);
      },
      set() {
        this.selectSpots([]);
      },
    },
  },
  created() {
    this.state.check = this.getData(this.ikey) || {};
    this.emitter.trigger('process', this.control);
  },
  methods: {
    // Multiple heart sound spots might become relevant later when we do cardiac cases
    // selectSpots(spots) {
    //   this.state.check.spots = spots;
    //   this.update();
    // },
    setValue(value) {
      this.state.check.value = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        ...this.state.check,
        type: 'HEART_SOUND',
        operator: 'EQUAL',
        spots: [0],
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.heart-sound-check {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
